import { useState, useCallback, useMemo } from "react";
import { AddTouchpointsFromTemplateModal } from "components/modals/add-touchpoints-from-template-modal/add-touchpoints-from-template-modal";
import { useCurrentCampaign } from "hooks/api/use-campaigns";

interface UseAddFromTemplateModalProps {
  folderId?: string;
  onSuccess?: () => void;
}

export const useAddFromTemplateModal = (props?: UseAddFromTemplateModalProps) => {
  const folderId = props?.folderId;
  const onSuccess = props?.onSuccess;
  const [isAddFromTemplateOpen, setIsAddFromTemplateOpen] = useState(false);

  const currentCampaign = useCurrentCampaign();

  const openAddFromTemplate = useCallback(() => setIsAddFromTemplateOpen(true), []);
  const closeAddFromTemplate = useCallback(() => setIsAddFromTemplateOpen(false), []);

  const handleSuccess = useCallback(() => {
    onSuccess?.();
    closeAddFromTemplate();
  }, [onSuccess, closeAddFromTemplate]);

  const addFromTemplateModalMarkup = useMemo(() => {
    if (!isAddFromTemplateOpen) return null;

    return (
      <AddTouchpointsFromTemplateModal
        setIsOpen={closeAddFromTemplate}
        campaignObjective={currentCampaign.campaignObjective || ""}
        onSuccess={handleSuccess}
        folderId={folderId}
      />
    );
  }, [
    isAddFromTemplateOpen,
    closeAddFromTemplate,
    currentCampaign.campaignObjective,
    handleSuccess,
    folderId,
  ]);

  return {
    openAddFromTemplate,
    closeAddFromTemplate,
    addFromTemplateModalMarkup,
  };
};
